module.exports = ".report-status span.inprogress {\n  color: #ffc107;\n  font-weight: bolder; }\n\n.report-status span.complete {\n  color: #4caf50;\n  font-weight: bolder; }\n\n.report-status span.failed {\n  color: red;\n  font-weight: bolder; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/scss/report-common.scss
// module id = ./src/app/report/scss/report-common.scss
// module chunks = main